import Slider, { SliderSingleProps } from 'antd/es/slider';
import clsx from 'clsx';

import './OpSlider.scss';

interface OpSliderProps extends SliderSingleProps {
  testId?: string;
}

export const OpSlider = ({
  className,
  testId = 'op-slider',
  ...rowProps
}: OpSliderProps) => {
  return (
    <Slider
      className={clsx('op-slider', className)}
      data-testid={testId}
      {...rowProps}
    />
  );
};
